import TransactionsListComponent from "../transactions-list.component";
import Grid from "@mui/material/Grid";
import { useAuth } from "../../core/context/auth.context";
import { useNavigate } from "react-router-dom";
import useScreenSize from "../../core/hooks/use-screen-size";
import useUserOs from "../../core/hooks/use-user-os";
import { useState } from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import {
  DateRange,
  DateRangePicker,
} from "../../core/components/date-range-picker";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import TransactionType from "@homegame/common/dist/enum/transaction-type.enum";
import TableInterface from "@homegame/common/dist/interface/table.interface";
import SelectTableComponent from "../components/table-select.component";
import SelectTypeComponent from "../components/type-select.component";

const useStyles = makeStyles(() =>
  createStyles({
    btnsContainer: {
      display: "flex",
      justifyContent: "center",
      height: 55,
      padding: 10,
      borderBottom: "1px solid rgba(255,255,255,.2)",
      marginBottom: 10,
      marginTop: 5,
      "& .MuiButtonGroup-root ": {
        marginRight: 10,
        minWidth: 145,
        "& .MuiButtonGroup-lastButton, & .MuiButtonGroup-firstButton": {
          display: "none",
        },
        "& div": {
          borderRadius: 15,
        },
      },
    },
    btn: {
      border: "1px solid rgba(255,255,255,.5)",
      color: "rgba(255,255,255,.7)",
      "& .MuiButtonBase-root": {
        color: "rgba(255,255,255,.7)",
        "& .MuiSvgIcon-root": {
          fontSize: 17,
          position: "relative",
          zIndex: 9,
        },
      },
      "& .MuiButton-root": {
        color: "rgba(255,255,255,.7)",
        fontSize: 13,
        textTransform: "none",
        "& .MuiSvgIcon-root": {
          marginRight: 10,
          marginLeft: 5,
          fontSize: 17,
        },
      },
    },
  }),
);

export default function TabAllPayments() {
  const classes = useStyles({});

  const { user } = useAuth();
  const navigate = useNavigate();
  const screenSize = useScreenSize();
  const { isIOS } = useUserOs();

  const [selectedTableId, setSelectedTableId] = useState<TableInterface[]>([]);
  const [selectedType, setSelectedType] = useState<TransactionType[]>([]);

  const [open, setOpen] = useState(false);
  const [dateRange, setDateRange] = useState<DateRange | undefined>();

  const handleChangeType = (types: TransactionType[]) => setSelectedType(types);

  const handleChangeTableId = (tables: TableInterface[]) =>
    setSelectedTableId(tables);

  const toggle = () => setOpen(!open);

  const getDatesString = () => {
    if (!dateRange) return "Select date";
    const { label, startDate, endDate } = dateRange;
    if (label) return label;
    if (!startDate || !endDate) return "Select date";
    return `${startDate.format("DD MMM")} - ${endDate.format("DD MMM")}`;
  };

  const changeRange = (range: DateRange) => {
    setDateRange(range);
    toggle();
  };

  const clearDate = () => {
    setDateRange(undefined);
  };

  const innerContainerSize = screenSize.height - (isIOS ? 300 : 285); // magic numbers

  const onTransactionStatusChanged = () => {
    navigate(0);
  };

  return (
    <>
      <Grid item sm={12} xs={12} className={classes.btnsContainer}>
        <ButtonGroup variant="outlined">
          <div className={classes.btn}>
            <Button
              variant="text"
              style={{ paddingRight: dateRange ? 0 : 15, paddingLeft: 5 }}
              onClick={() => setOpen(true)}
            >
              <CalendarMonthIcon />
              {getDatesString()}
            </Button>
            {dateRange && (
              <IconButton
                onClick={clearDate}
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <ClearIcon />
              </IconButton>
            )}
          </div>
        </ButtonGroup>

        <SelectTypeComponent
          onChange={handleChangeType}
          selectedType={selectedType}
        />

        <SelectTableComponent
          selectedTable={selectedTableId}
          onChange={handleChangeTableId}
        />

        <br />
        <br />
      </Grid>
      <Grid item xs={12} height="80vh">
        <TransactionsListComponent
          height={innerContainerSize}
          showStatus
          pageSize={Math.floor((innerContainerSize - 100) / 80)}
          showTableName
          onActionDone={onTransactionStatusChanged}
          filters={{
            dateFrom: dateRange?.startDate?.utc().format(),
            dateTo: dateRange?.endDate?.utc().format(),
            type: selectedType,
            tableId: selectedTableId.map(({ id }) => id!),
            userId: user?.id,
          }}
        />
        <DateRangePicker open={open} toggle={toggle} onChange={changeRange} />
      </Grid>
    </>
  );
}
